/**
 * Given a list of menu-entry texts, find the next entry (cyclic) whose text
 * starts with the given key character.
 *
 * - Search starts at `currentIndex + 1` and wraps once back to `currentIndex`.
 * - `currentIndex < 0` means "no current focus" — search starts at 0.
 * - Case-insensitive. Leading whitespace in entry text is ignored.
 * - Returns the matching index, or `null` if nothing matches.
 */
export function findTypeaheadTarget(
  texts: readonly string[],
  currentIndex: number,
  key: string
): number | null {
  if (texts.length === 0 || key.length !== 1) return null;
  const needle = key.toLowerCase();
  const start = currentIndex < 0 ? 0 : (currentIndex + 1) % texts.length;
  const skipIdx = currentIndex < 0 ? -1 : currentIndex;
  for (let offset = 0; offset < texts.length; offset++) {
    const idx = (start + offset) % texts.length;
    if (idx === skipIdx) continue;
    if (texts[idx].trimStart().charAt(0).toLowerCase() === needle) return idx;
  }
  // Fall back to checking the current entry itself if nothing else matched.
  if (
    currentIndex >= 0 &&
    currentIndex < texts.length &&
    texts[currentIndex].trimStart().charAt(0).toLowerCase() === needle
  ) {
    return currentIndex;
  }
  return null;
}
